module.exports = __webpack_public_path__ + "src/img/disk.b1571fb2.png";